import {MutationTree} from 'vuex'
import {initialState, MembersDataState} from '@/store/modules/members'

export const mutations: MutationTree<MembersDataState> = {

    setProcessStatuses: (state, processStatuses) => {
        state.processStatuses = processStatuses
        state.isEmpty = false
    },

    resetState: (state) => {
        state = Object.assign(state, initialState())
    }

}